import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BoardComponent } from './board/board.component';
import { SnakeComponent } from './snake/snake.component';
import { BitComponent } from './bit/bit.component';
import { FoodComponent } from './food/food.component';
import { BrickComponent } from './brick/brick.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OptionsComponent } from './options/options.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { ToolsComponent } from './tools/tools.component';
import { VerlibaSharedModule } from '../verliba-shared';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSliderModule} from '@angular/material/slider';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    BoardComponent,
    SnakeComponent,
    BitComponent,
    FoodComponent,
    BrickComponent,
    OptionsComponent,
    ToolsComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatProgressBarModule,
    MatTooltipModule,
    VerlibaSharedModule,
    HttpClientModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
